import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { ConditionType } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useConditionTypesQuery(
	options?: Omit<UseQueryOptions<ConditionType[], unknown, ConditionType[], any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Lookups.ConditionTypes,
		() => AxiosUtils.getResponseData<ConditionType[]>(api.get(CerebroApiEndpoints.Lookups.ConditionTypes)),
		options
	);
}
